import { useEffect, useState } from "react";
import { getToken } from "firebase/messaging";
import { messaging } from "../firebase";
import { FIREBASE_NOTIFICATION_VAPID_KEY } from "../clientConfig";

const VAPID_KEY = FIREBASE_NOTIFICATION_VAPID_KEY;

const useFirebaseToken = () => {
  const [token, setToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted" && messaging) {
          const currentToken = await getToken(messaging, {
            vapidKey: VAPID_KEY,
          });
          if (currentToken) {
            setToken(currentToken);
          } else {
            setError("No registration token available.");
          }
        } else if (permission === "denied") {
          setError("You denied the notification request.");
        }
      } catch (err) {
        console.error("An error occurred while retrieving the token.", err);
        setError(err instanceof Error ? err.message : String(err));
      }
    };

    fetchToken();
  }, []);

  return { token, error };
};

export default useFirebaseToken;
